import BasketStorage from "../storage/basket-storage";

export default function reducer(state = BasketStorage, action) {
  switch (action.type) {
    case "ADD": {
      const newState = state.clone();
      newState.addItem(action.payload);
      return newState;
    }
    case "SET_MASTER_DATA": {
      const newState = state.clone();
      newState.setMasterData(action.stammdaten);
      return newState;
    }
    case "METALS_SET_LIST_DATA":
    case "CURRENCIES_SET_LIST_DATA": {
      const newState = state.clone();
      newState.updateData(action.payload);
      return newState;
    }
    case 'SET_APP_ID': {
      const newState = state.clone();
      newState.setCurrentShopIsAnkauf(!!String(action.payload).match(/(Rage|VNeo)(Em|So)(Bp|Wl|Ma)Sell/));
      return newState;
    }
    case "SET_CURRENT_SHOP_IS_ANKAUF": {
      const newState = state.clone();
      newState.setCurrentShopIsAnkauf(action.payload);
      return newState;
    }
    case "CHANGE_DUES": {
      const newState = state.clone();
      newState.changeDues(action.item, action.due);
      return newState;
    }
    case "CHANGE_SHIPPING": {
      const newState = state.clone();
      newState.shipping = action.payload.clone();
      return newState;
    }
    case "SET_GEBUEHREN": {
      const newState = state.clone();
      newState.setGebuehren(action.gebuehren);
      return newState;
    }
    case "CHANGE_AMOUNT": {
      const newState = state.clone();
      newState.changeAmount(action.payload.id, action.amount);
      return newState;
    }
    case "INCREMENT_ITEM": {
      const newState = state.clone();
      newState.incrementItem(action.payload.id);
      return newState;
    }
    case "DECREMENT_ITEM": {
      const newState = state.clone();
      newState.decrementItem(action.payload.id);
      return newState;
    }
    case "REMOVE_ITEM": {
      const newState = state.clone();
      newState.removeItem(action.payload.id);
      return newState;
    }
    case "RESET_FILIALE_AND_SHIPMENT": {
      const newState = state.clone();
      newState.selectedFiliale = null;
      newState.setDoShip("no");
      return newState;
    }
    case "SET_DO_SHIP": {
      const newState = state.clone();
      newState.setDoShip(action.payload);
      return newState;
    }
    case "BASKET_UPDATE_SUM": {
      const newState = state.clone();
      if (String(action.payload).match(/^(yes|no)$/)) {
        newState.setDoShip(action.payload);
      }
      newState.updateSum();
      return newState;
    }
    case "METALS_RESET_DATA": {
      const newState = state.clone();
      newState.setClean();
      return newState;
    }
    case "SET_WARENKORB_ID": {
      const newState = state.clone();
      newState.setWarenkorbId(action.payload);
      return newState;
    }
    case "SET_DATA_FOR_ORDER": {
      const newState = state.clone();
      newState.setDataForOrder(action.data);
      return newState;
    }
    case "BASKET_REBUILD_FOR_APPROVAL": {
      const newState = state.clone();
      newState.rebuildForApproval(action.data);
      return newState;
    }
    case "SET_SELECTED_FILIALE": {
      const newState = state.clone();
      newState.setSelectedFiliale(action.payload);
      return newState;
    }
    case "RESTORE_DATA": {
      const newState = state.clone();
      newState.restoreData(action.payload);
      return newState;
    }
    case "RESET_WARENKORB": {
      const newState = state.clone();
      newState.resetWarenkorb();
      return newState;
    }
    case "SET_BANKAPIRESPONSEDATA": {
      const newState = state.clone();
      newState.setBankApiResponseData(action.payload);
      return newState;
    }   
    case "SET_ORDER_LIMIT": {
      const newState = state.clone();
      newState.setOrderLimit(action.state);
      return newState;
    }
    default:
      return state;
  }
}
